/* unplugin-vue-components disabled */import { render } from "./PositionBizInfo.vue?vue&type=template&id=eeae7320&scoped=true"
import script from "./PositionBizInfo.vue?vue&type=script&lang=js"
export * from "./PositionBizInfo.vue?vue&type=script&lang=js"

import "./PositionBizInfo.vue?vue&type=style&index=0&id=eeae7320&lang=scss&scoped=true"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeae7320"]])

export default __exports__